<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-apply"
    :title="title"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <el-form :model="formData" :rules="rules" ref="modifyForm">
      <div class="item-base">
        <div class="form-item">
          <div class="label">姓名<span class="requiredcolor">*</span></div>
          <el-form-item prop="receive_name">
            <el-input
              class="custom-input width222"
              v-model="formData.receive_name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="label">电话号码<span class="requiredcolor">*</span></div>
          <el-form-item prop="phone_user">
            <el-input
              class="custom-input width222"
              v-model="formData.phone_user"
              placeholder="请输入"
              maxlength="11"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="form-item">
        <div class="label">公司名称<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_004">
          <el-input
            class="custom-input"
            v-model="formData.append_order_remark_004"
            placeholder="请输入"
            maxlength="32"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">微信号<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_005">
          <el-input
            class="custom-input"
            v-model="formData.append_order_remark_005"
            placeholder="请输入"
            maxlength="11"
          ></el-input>
        </el-form-item>
      </div>
      <div class="item-base">
        <div class="form-item">
          <div class="label">所在地<span class="requiredcolor">*</span></div>
          <el-form-item prop="province">
            <CustomSelect
              v-model="formData.province"
              class="width222 el-select-area"
              @change="handleCityChange"
              popper-class="selectArea"
              placeholder="省份"
            >
              <el-option
                v-for="(item, idx) in provinces"
                :key="idx"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </CustomSelect>
          </el-form-item>
        </div>
        <div class="form-item">
          <div class="label"></div>
          <el-form-item prop="city">
            <CustomSelect
              v-model="formData.city"
              class="width222 el-select-area"
              popper-class="selectArea"
              placeholder="城市"
            >
              <el-option
                v-for="(item, idx) in cities"
                :key="idx"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </CustomSelect>
          </el-form-item>
        </div>
      </div>
      <div class="form-item">
        <div class="label">预算</div>
        <el-form-item>
          <el-input
            class="custom-input"
            v-model="formData.append_order_remark_007"
            placeholder="请输入"
            maxlength="11"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">开发语言需求</div>
        <el-form-item>
          <!-- <el-input
            class="custom-input"
            v-model="formData.append_order_remark_008"
            placeholder="请输入"
            maxlength="11"
          ></el-input> -->
          <!-- class="width690" -->
          <CustomSelect
            style="width: 100%; min-height: 46px"
            :multiple-limit="3"
            multiple
            v-model="formData.append_order_remark_008"
            placeholder="请选择"
            popper-class="customselect-popper"
            value-key="value"
            otherValue="329"
          >
            <el-option
              v-for="(item, idx) in devlangOptions"
              :key="idx"
              :label="item.text"
              :value="item"
              :remark="item.value"
            >
            </el-option>
          </CustomSelect>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">是否有需求明细</div>
        <div class="upload-tip-box">
          <el-upload
            action="no"
            :auto-upload="false"
            :multiple="false"
            :file-list="showFileList"
            :show-file-list="false"
            :on-change="
              (file, fileList) => {
                handleChange(file, fileList, 'add');
              }
            "
          >
            <el-button class="custom-button btn-border btn-upload"
              >上传文件</el-button
            >
          </el-upload>
          <div class="tip">文件格式：png/jpg/pdf/doc/xls</div>
        </div>
      </div>
      <div class="filelist-box">
        <div class="item" v-for="(item, idx) in showFileList" :key="idx">
          {{ item.name }}<i class="el-icon-close" @click="handleClearFile(item, idx)"></i>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-e0e0e0" @click="handleCloseDialog"
        >取消</el-button
      >
      <el-button class="custom-button btn-determine" @click="handleSubmit"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { Base64 } from "js-base64";
import { phoneValidator, timeLoop } from "@/assets/js/util";
import lodash from "lodash";
// import { city } from "@/assets/js/city";
import { city } from "@/utils/cityjs/applycity";
import { developLangOptions } from "@/assets/js/dictionary";
import CustomSelect from "@/components/CustomSelect.vue";
import pageCommon from "@/utils/pagecommon";
import caseApi from "@/api/case";
export default {
  name: "ApplyInfo",
  components: {
    CustomSelect,
  },
  data() {
    return {
      showDialog: false,
      devlangOptions: lodash.cloneDeep(developLangOptions),
      origin_devlangOptions: [],
      hostUrl: window.location.host,
      formData: {
        receive_name: "",
        phone_user: "",
        append_order_remark_004: "",
        append_order_remark_005: "",
        append_order_remark_006: "",
        province: "",
        city: "",
        append_order_remark_007: "",
        append_order_remark_008: [],
        append_order_remark_009: "",
      },
      timerObj: {
        timer: null,
      },
      timeCount: 0,
      maxTime: 60,
      sendCodeText: "发送验证码",
      provinces: city,
      cities: [],
      rules: {
        receive_name: [
          { required: true, message: "填写姓名", trigger: "blur" },
        ],
        phone_user: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        append_order_remark_004: [
          { required: true, message: "填写公司名称", trigger: "blur" },
        ],
        append_order_remark_005: [
          { required: true, message: "填写微信号", trigger: "blur" },
        ],
        code: [{ required: true, message: "填写手机验证码", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "填写验证码", trigger: "blur" },
        ],
        pwd: [{ required: true, message: "填写密码", trigger: "blur" }],
      },
      showFileList: [
        // {
        //   name: "food.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
        // {
        //   name: "food2.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
      isRequesting: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    goodData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    let _this = this;
    _this.getOssData();
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let userInfo = _this.$store.state.user;
      return userInfo;
    },
    userShopInfo: function () {
      let _this = this;
      let userShopInfo = _this.$store.state.userShopInfo;
      return userShopInfo;
    },
  },
  methods: {
    getOssData() {
      if (!this.$cookies.get("ossParams")) {
        const res = {
          oss_host_url: 'https://global-application-saved.downline.cn',
          app_main_url: this.hostUrl,
          oss_accesskey: "hgV5TOnVHZWvXYV98QMqm1Avt7Q3mD",
          oss_accessid: "scj0YOTsBy74ZWGy",
        };
        const ossParams = {
          key: res["app_main_url"] + "/goods_image/",
          accesskey: res["oss_accesskey"],
          OSSAccessKeyId: res["oss_accessid"],
        };
        this.$cookies.set(
          "ossParams",
          Base64.encode(JSON.stringify(ossParams))
        );
      }
    },
    dealWithMultipleData: function (
      listname,
      resdata,
      othervalue,
      other_remark_value
    ) {
      let _this = this;
      let arrRes = resdata ? resdata.split(",") : [];
      let selectedData = [];
      let list = _this[listname];
      for (let i = 0; i < arrRes.length; i++) {
        const tmpRes = arrRes[i];
        for (let j = 0; j < list.length; j++) {
          const tmpitem = list[j];
          if (tmpitem.value == tmpRes) {
            if (tmpitem.value == othervalue) {
              tmpitem.remark = other_remark_value;
            }
            selectedData.push(tmpitem);
          }
        }
      }
      _this[`origin_${listname}`] = lodash.cloneDeep(list);
      return selectedData;
    },
    getDetailInfo: function () {
      let _this = this;
      let id_public_goods_order_record =
        _this.id ||
        _this.userShopInfo.public_goods_order_record
          .id_public_goods_order_record;
      if (_this.id) {
        let requestData = {
          id_public_goods_order_record: id_public_goods_order_record,
          isloading: true,
        };
        pageCommon.apiRequestCommon(caseApi, "orderDetail", requestData).then(
          (res) => {
            let detail =
              res && res.public_goods_order_record
                ? res.public_goods_order_record
                : null;
            if (detail) {
              if (detail.append_order_remark_006) {
                let addressArr = detail.append_order_remark_006.split("-_-");
                detail.province = addressArr[0];
                detail.city = addressArr[1];
                _this.formData.province = addressArr[0];
                console.log("11111:");
                console.log(_this.formData.province);
                _this.handleCityChange();
              }
              // console.log(detail.append_order_remark_008)
              // 开发语言
              if (
                (detail.append_order_remark_008 ||
                  detail.append_order_remark_008 === "0" ||
                  detail.append_order_remark_008 === 0)
              ) {
                let append_order_remark_008_val = detail.append_order_remark_008;
                let append_order_remark_008 = _this.dealWithMultipleData(
                  "devlangOptions",
                  append_order_remark_008_val,
                  329,
                  ""
                );
                detail.append_order_remark_008 = append_order_remark_008;
              } else{
                detail.append_order_remark_008 = [];
              }

              let fileurls;
              let showlist = [];
              if(detail.append_order_remark_009 === -1 || !detail.append_order_remark_009){
                showlist = [];
              }else{
                fileurls = detail.append_order_remark_009.split(",");
                for (let i = 0; i < fileurls.length; i++) {
                  const element = fileurls[i];
                  showlist.push(_this.getFileNameFromUrl(element));
                }
                _this.showFileList = showlist;
              }

              _this.formData = detail;
            } else {
              _this.showFileList = [];
            }
          },
          (err) => {
            _this.isRequesting = false;
            if (err.sysUserLoginError) {
              _this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              _this.$message.error(err.data.msg);
            }
          }
        );
      } else {
        if (_this.userInfo) {
          _this.formData.receive_name = _this.userInfo.nick_name
            ? _this.userInfo.nick_name
            : "";
          _this.formData.phone_user = _this.userInfo.user_phone
            ? _this.userInfo.user_phone
            : "";
          _this.formData.append_order_remark_004 = _this.userInfo
            .user_remark_005
            ? _this.userInfo.user_remark_005
            : "";
        }
      }
    },
    handleCityChange: function () {
      let _this = this;
      let cities = [];

      for (let i = 0; i < city.length; i++) {
        const element = city[i];
        if (element.areaId == _this.formData.province) {
          cities = element.child;
          break;
        }
      }
      _this.formData.city = "";
      _this.cities = cities;
    },
    handleCloseDialog: function () {
      let _this = this;
      if (_this.timerObj && _this.timerObj.timer) {
        clearTimeout(_this.timerObj.timer);
      }
      _this.showDialog = false;
    },
    handleSubmit: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      // _this.isRequesting = true;
      _this.$refs["modifyForm"].validate((valid) => {
        if (valid) {
          // _this.$message.success("修改成功");
          if (!_this.id) {
            _this.numChangeMain();
          } else {
            _this.preSubmitMain();
          }
        }
      });
    },
    numChangeMain: function () {
      let _this = this;
      let requestData = {
        id_public_goods_order_record:
          _this.id ||
          _this.userShopInfo.public_goods_order_record
            .id_public_goods_order_record,
        order_detail_change_data: `${_this.goodData.id_public_goods_info}-_-2`,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "numChange", requestData).then(
        (res) => {
          _this.preSubmitMain();
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    preSubmitMain: function () {
      let _this = this;
      let id_public_goods_order_record =
        _this.id ||
        _this.userShopInfo.public_goods_order_record
          .id_public_goods_order_record;
      let append_order_remark_006 = `${_this.formData.province}-_-${_this.formData.city}`;
      let append_order_remark_009 = [];
      if(_this.showFileList.length == 0){
        append_order_remark_009 =-1;
      }else{
        for (let i = 0; i < _this.showFileList.length; i++) {
          const element = _this.showFileList[i];
          append_order_remark_009.push(element.url);
        }
        append_order_remark_009 = append_order_remark_009.join(",")
      }

      let append_order_remark_008_val="";
      if(_this.formData.append_order_remark_008&&_this.formData.append_order_remark_008.length>0){
        let append_order_remark_008_arr=[];
        for (let i = 0; i < _this.formData.append_order_remark_008.length; i++) {
          const element = _this.formData.append_order_remark_008[i];
          append_order_remark_008_arr.push(element.value);
        }
        append_order_remark_008_val=append_order_remark_008_arr.join(",");
      }
      let requestData = {
        id_public_goods_order_record: id_public_goods_order_record,
        phone_user: _this.formData.phone_user,
        receive_name: _this.formData.receive_name,
        append_order_remark_004: _this.formData.append_order_remark_004,
        append_order_remark_005: _this.formData.append_order_remark_005,
        append_order_remark_006: append_order_remark_006,
        append_order_remark_007: _this.formData.append_order_remark_007,
        append_order_remark_008:append_order_remark_008_val, //_this.formData.append_order_remark_008,
        append_order_remark_009: append_order_remark_009,
        isloading: true,
      };
      // console.log(requestData,"xxxxx")
      pageCommon.apiRequestCommon(caseApi, "preSubmit", requestData).then(
        (res) => {
          if (_this.id) {
            _this.$message.success("完善资料成功");
            _this.showDialog = false;
          } else {
            _this.payMain();
          }
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    payMain: function () {
      let _this = this;
      let id_public_goods_order_record =
        _this.id ||
        _this.userShopInfo.public_goods_order_record
          .id_public_goods_order_record;
      let requestData = {
        id_public_goods_order_record: id_public_goods_order_record,
        isloading: true,
      };
      pageCommon.apiRequestCommon(caseApi, "pay", requestData).then(
        (res) => {
          _this.isRequesting = false;
          _this.$message.success("提交成功");
          _this.resetPublicOrderRecord(res.new_next_order_record);
          _this.showDialog = false;
          _this.$emit("reloadList");
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    resetPublicOrderRecord: function (next) {
      let _this = this;
      let data = _this.userShopInfo;
      if (data) {
        data.public_goods_order_record = next;
        storage.set("usershop", JSON.stringify(data));
        _this.$store.dispatch("acUserShopInfo", data);
      }
    },
    handleClearFile: function (item, idx) {
      let _this = this;
      _this.showFileList.splice(idx, 1);
    },
    handleChange: function (file, fileList) {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      if (_this.showFileList.length >= 3) {
        _this.$message.error("最多上传三个文件");
        return;
      }
      _this.isRequesting = true;
      if (file.status !== "ready") {
        _this.isRequesting = false;
        return;
      }
      let data = this.$cookies.get("ossParams");
      if (!data) {
        this.$message.error("上传失败，缺少ossParams");
        return;
      }
      data = JSON.parse(Base64.decode(data));

      this.$upload(data, file, false).then(
        (res) => {
          let tmpData = _this.getFileNameFromUrl(res);
          _this.showFileList.push(tmpData);
          _this.isRequesting = false;
          // if (type && type === 'add') {
          //   this.uploadSucc(this.keyWord, this.index, { image_url: res }, 'add')
          // } else if (type && type === 'replace') {
          //   this.uploadSucc(this.keyWord, this.index, { image_url: res }, 'replace')
          // }
        },
        (error) => {
          _this.$message.error(error);
          _this.isRequesting = false;
        }
      );
    },
    getFileNameFromUrl: function (url) {
      let _this = this;
      var index = url.lastIndexOf("/");
      let name = url.substr(index + 1);
      let data = { name: name, url: url };
      return data;
    },
    spliceDevOtherVal:function(){
      let _this=this;
      let idx=-1;
      for (let i = 0; i < _this.devlangOptions.length; i++) {
        const element = _this.devlangOptions[i];
        if(element.code==-1){
          idx=i;
          break;
        }
      }
      if(idx!==-1){
         _this.devlangOptions.splice(idx,1);
      }

    }
  },
  watch: {
    goodData: {
      handler: function (newVal, oldVal) {
        let _this = this;
        _this.spliceDevOtherVal();
        _this.formData = {
          receive_name: "",
          phone_user: "",
          append_order_remark_004: "",
          append_order_remark_005: "",
          append_order_remark_006: "",
          province: "",
          city: "",
          append_order_remark_007: "",
          append_order_remark_008: [],
          append_order_remark_009: "",
        };
        _this.showFileList = [];
        _this.$refs["modifyForm"].clearValidate();
        _this.getDetailInfo();
        _this.isRequesting = false;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-apply {
  /deep/.el-dialog {
    position: absolute;
    width: 540px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 38px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0px 38px 0;
      width: 100%;
      box-sizing: border-box;
      max-height: calc(100vh - 260px);
      box-sizing: border-box;
      overflow: auto;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
  }
  .width222 {
    width: 222px;
  }
  .width100per {
    width: 100%;
  }
  .item-base {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .form-item {
    display: flex;
    flex-direction: column;
    /deep/.custom-input {
      .el-input__inner {
        font-size: 16px;
        font-family: Source Han Sans CN;
        // font-weight: bold;
        color: #222222;
        &::-webkit-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-moz-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-ms-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }
      }
    }
    .label {
      font-size: 12px;
      font-family: "SourceHanSansCN";
      color: rgb(153, 153, 153);
      margin-bottom: 5px;
      text-align: left;
      .red {
        color: #ff3333;
      }
    }
    .el-select-area {
      /deep/.el-input__inner {
        font-size: 16px;
        font-family: Source Han Sans CN;
        // font-weight: bold;
        color: #222222;
        &::-webkit-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-moz-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-ms-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }
      }
    }
    .upload-tip-box {
      display: flex;
      align-items: center;
      .btn-upload {
        width: 70px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
      }
      .tip {
        font-size: 12px;
        font-family: "SourceHanSansCN";
        color: rgb(153, 153, 153);

        margin-left: 15px;
      }
      /deep/.el-upload {
        border: none;
        width: auto;
        height: auto;
      }
    }
  }
  .filelist-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 15px;
    .item {
      display: flex;
      align-items: center;

      border-radius: 4px;
      background-color: rgb(246, 246, 246);
      height: 24px;
      line-height: 24px;
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;
      margin-right: 5px;

      font-size: 12px;
      font-family: "SourceHanSansCN";
      color: rgb(34, 34, 34);
      .el-icon-close {
        font-size: 12px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }

  // /deep/.el-dialog__header {
  //   text-align: left;
  //   padding: 30px 40px 40px;
  //   .el-dialog__title {
  //     text-align: left;
  //     font-size: 20px;
  //     font-family: "SourceHanSansCN";
  //     color: rgb(34, 34, 34);
  //     font-weight: 700;
  //   }
  // }
  /deep/.el-dialog__footer {
    padding: 20px 40px;
  }
  /deep/.el-dialog__footer {
    position: relative;
    width: 100%;
    padding: 0;
    padding-bottom: 30px;
    /* padding-top: 0; */
    padding-right: 38px;
    padding-top: 34px;
  }
  /deep/.dialog-footer {
    display: flex;
    justify-content: flex-end;
    .custom-button {
      width: 80px;
      height: 46px;
      line-height: 46px;

      font-size: 16px;

      margin-left: 25px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
